'use client';

import { ChangeEvent } from 'react';
import ReactCurrencyInput, {
  type CurrencyInputProps as ReactCurrencyInputProps,
} from 'react-currency-input-field';

import { useInputContext } from './input-context';
import { inputControl, type InputVariantProps } from './variants';

export type MaskedControlProps = ReactCurrencyInputProps & InputVariantProps;

export function MaskedControl({
  className,
  onChange,
  variant,
  ...props
}: MaskedControlProps) {
  const { id } = useInputContext();

  function onInputChange(event: ChangeEvent<HTMLInputElement>) {
    event.currentTarget.parentElement?.toggleAttribute(
      'data-has-value',
      Boolean(event.currentTarget.value),
    );

    onChange?.(event);
  }

  return (
    <ReactCurrencyInput
      id={id}
      onChange={onInputChange}
      className={inputControl({ className, variant })}
      {...props}
    />
  );
}
